import { ReactElement } from "react";

import ApprovalFields from "./approval-fields";
import { applicableDate } from "../../portfolio-agreement/agreement-dates";
import ReviewDetails from "./review-details";

interface DetailsPanelProps {
  record: any;
  awaitingDecision: boolean;
  dateValue: string | null;
  onDateChange: (iso: string | null) => void;
  regenerating: boolean;
}

/** Request details, plus a note when the record can no longer be acted on. */
const DetailsPanel: React.FC<DetailsPanelProps> = ({
  record,
  awaitingDecision,
  dateValue,
  onDateChange,
  regenerating,
}): ReactElement => (
  <div className="panel">
    <header>
      <h4>Request details</h4>
    </header>
    <div className="body">
      {record ? (
        <>
          <ReviewDetails record={record} />
          <ApprovalFields
            type={record?.type}
            date={dateValue}
            originalDate={applicableDate(record)}
            // Only a record still awaiting a decision can have its date changed.
            editable={awaitingDecision}
            regenerating={regenerating}
            onDateChange={onDateChange}
          />
        </>
      ) : (
        <p style={{ color: "#949494", margin: 0 }}>Loading…</p>
      )}

      {record && !awaitingDecision && (
        <div className="notice is-info" style={{ marginTop: 18 }}>
          <p className="title">This request is not awaiting a decision</p>
          <p>
            Only requests with a review status of Awaiting review can be
            approved or returned.
          </p>
        </div>
      )}
    </div>
  </div>
);

export default DetailsPanel;
